fragment ComparisonEditionFragment on Edition {
    id
    viewInBrowserLink
    hasUnsubscribeLink
    hasStreetAddress
    modifiedTime
    emailTemplate {
        id
        subject
        previewText
        beeBodyJson
        thumbnailUrl
        modifiedTime
        links {
            url {
                id
                fullyQualifiedUrl
            }
        }
    }
}
